import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setAuthToken } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [permissions, setPermissions] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data.user);
      setPermissions(r.data.permissions || {});
      if (r.data.session_token) setAuthToken(r.data.session_token);
      return r.data.user;
    } catch (e) {
      setUser(null);
      setPermissions({});
      setAuthToken(null);
      return null;
    }
  }, []);

  useEffect(() => {
    (async () => {
      await refresh();
      setLoading(false);
    })();
  }, [refresh]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    setAuthToken(null);
    setUser(null);
    setPermissions({});
  }, []);

  return (
    <AuthCtx.Provider value={{ user, permissions, loading, refresh, setUser, setPermissions, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
